"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mergeSlotProps;
var _clsx = _interopRequireDefault(require("clsx"));
function mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) {
        return defaultSlotProps;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') {
        return (ownerState)=>{
            const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
            const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
                ...ownerState,
                ...defaultSlotPropsValue
            }) : externalSlotProps;
            const className = (0, _clsx.default)(ownerState === null || ownerState === void 0 ? void 0 : ownerState.className, defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.className, externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.className);
            return {
                ...defaultSlotPropsValue,
                ...externalSlotPropsValue,
                ...!!className && {
                    className
                },
                ...(defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.style) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.style) && {
                    style: {
                        ...defaultSlotPropsValue.style,
                        ...externalSlotPropsValue.style
                    }
                },
                ...(defaultSlotPropsValue === null || defaultSlotPropsValue === void 0 ? void 0 : defaultSlotPropsValue.sx) && (externalSlotPropsValue === null || externalSlotPropsValue === void 0 ? void 0 : externalSlotPropsValue.sx) && {
                    sx: [
                        ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                            defaultSlotPropsValue.sx
                        ],
                        ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                            externalSlotPropsValue.sx
                        ]
                    ]
                }
            };
        };
    }
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, _clsx.default)(typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.className, externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className
        },
        ...(typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.style) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.style) && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...(typedDefaultSlotProps === null || typedDefaultSlotProps === void 0 ? void 0 : typedDefaultSlotProps.sx) && (externalSlotProps === null || externalSlotProps === void 0 ? void 0 : externalSlotProps.sx) && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}
